<template>
    <div>
        <el-select
            v-if="multiple"
            v-model="selectRoles"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :multiple="true"
            :remote-method="queryRoleList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.id">
            </el-option>
        </el-select>

        <el-select
            v-else
            v-model="selectName"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="queryRoleList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getRoleList } from '@/data-model';
    // import { isEmpty } from 'lodash';

    export default {
        data () {
            return {
                loading: false,
                roleList: [],
                selectRoles: [],
                mutilUsers: '',
                selected: {
                    id: '',
                    roleName: ''
                },
                selectName: ''
            };
        },
        computed: {
            // selectRoles: {
            //     get () {
            //         if (isEmpty(this.mutilUsers)) {
            //             return [];
            //         }
            //         return this.mutilUsers.split(',');
            //     },
            //     set (newVal, oldVal) {
            //         this.mutilUsers = newVal.join(',');
            //         this.formData[this.field.formField] = newVal.join(',');
            //     }
            // }
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false
            }
        },
        created () {
            // this._setDefaultUser();
            this.queryRoleList('');
            this._initUsers();
        },
        methods: {
            async _initUsers () {
                this._setDefaultUser('');
            },
            _setDefaultUser (selectedRole) {
                if (selectedRole && !this.multiple) {
                    this.selectName = selectedRole.roleName;
                    this.formData[this.field.formField] = selectedRole.id;
                    this.formData[this.field.formField + '-role'] = selectedRole.roleName;
                } else if (selectedRole && this.multiple) {
                    this.selectRoles = selectedRole.split(',');
                }
            },
            async queryRoleList (roleName) {
                this.loading = true;
                let formData = await getRoleList(1, 500, roleName);
                this.roleList = formData.data;
                // console.log(this.roleList);
                this.loading = false;
            },
            selectTrigger (val) {
                if (this.multiple) {
                    if (this.formData) {
                        if (val) {
                            let names = [];
                            this.roleList.find((item) => {
                                val.find((it) => {
                                    if (item.id === it) {
                                        names.push(item.roleName);
                                    }
                                });
                            });
                            this.formData[this.field.formField] = val.join(',');
                            this.formData[this.field.formField + '-role'] = names.join(',');
                        } else {
                            this.roleList = [];
                            this.formData[this.field.formField] = '';
                            this.formData[this.field.formField + '-role'] = '';
                        }
                        // console.log(this.formData[this.field.formField]);
                        // console.log(this.formData[this.field.formField + '-role']);
                    }
                } else {
                    if (val) {
                        this.selected = this.roleList.find((item) => {
                            return item.id === val;
                        });
                    } else {
                        this.selected = {id: '', roleName: ''};
                    }
                    if (this.formData) {
                        this.formData[this.field.formField] = this.selected.id;
                        this.formData[this.field.formField + '-role'] = this.selected.roleName;
                    }
                }
                this.$emit('nodeClick', {id: this.selected.id, label: this.selected.roleName});
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/RolePop/RolePop.vue